import React from 'react';
import { motion } from 'framer-motion';

const PhilosophyCard = ({ number, title, description, delay }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
      className="bg-white p-8 rounded-xl shadow-custom relative z-10 border-t-4 border-secondary"
    >
      <div className="absolute -top-6 -left-6 bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold font-heading">
        {number}
      </div>
      <h3 className="text-xl font-heading font-semibold text-primary mb-4 pt-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </motion.div>
  );
};

const PhilosophySection = () => {
  const philosophies = [
    {
      number: "01",
      title: "Long-Term Perspective",
      description: "We focus on long-term wealth creation rather than short-term market fluctuations, allowing us to capitalize on sustainable growth opportunities."
    },
    {
      number: "02",
      title: "Risk Management",
      description: "Our rigorous risk management framework aims to protect capital during market downturns while capturing upside potential during favorable conditions."
    },
    {
      number: "03",
      title: "Diversification",
      description: "We believe in strategic diversification across asset classes, geographies, and investment styles to reduce portfolio volatility and enhance returns."
    },
    {
      number: "04",
      title: "Research-Driven Approach",
      description: "Our investment decisions are based on deep fundamental research, quantitative analysis, and a thorough understanding of global markets."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-primary/10 to-background relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-10">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-secondary/30 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-secondary/30 rounded-full blur-3xl"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-heading font-bold text-primary mb-6">Our Investment Philosophy</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Segway Capital Management follows a disciplined investment approach built on timeless principles and cutting-edge research.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connected line between cards */}
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-secondary/20 hidden lg:block"></div>
          
          {philosophies.map((philosophy, index) => (
            <PhilosophyCard 
              key={index}
              number={philosophy.number}
              title={philosophy.title}
              description={philosophy.description}
              delay={0.1 * index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection; 